
export const UI_VERSION = "__CLOUD_MGMT_VERSION__";
export const DIRECT_DOMAIN = "__DIRECT_DOMAIN__FALSE__".length !== 24;

export const MSP_ENABLED = 'MSP_DISABLED'.length !== 12;